<template>
  <div class="card-header text-center ">
    <h5> سبد خرید شما</h5>
  </div>
  <div class="card-body">
    <checkout/>
    <div class="row">
      <div class="d-flex flex-row justify-content-end">
        <button v-if="count > 0 " class="btn btn-danger"  @click="methodPayment('true')">
          مرحله بعدی
        </button>

      </div>
    </div>
  </div>
</template>
<script setup>
import checkout from "@/agent/components/checkout/listsBasket.vue"
import {useStore} from 'vuex'
import {computed} from "vue";
const store = useStore()

const count = computed(() => {
  if (!store.state.listCard) {
    store.state.listCard = [];
  }
  return store.state?.listCard.length
})

function methodPayment(status) {
  store.dispatch('statusStep', {'status': status});
}
</script>

